<template>
  <TableTemplate class="OverviewOrder"
    v-model="mappedOrders"

    :columns="tableColumns"
    :columnVariables="tableColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :max="max"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="viewOrder"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Overzicht bestellingen"
        :alwaysShowMultiSelectCheckbox="false"
        :refetch="refetch"
        :exportParams="exportEndpointParams"

        csv-name="orders"
        export-endpoint="/api/orders/export"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addOrder"
          >
            Bestelling toevoegen
          </HeaderButton>
        </template>
      </TableHeader>
      <div class="d-flex flex-row-reverse">
        <MultiplePageSizesSelection
          v-model="page_size"
          :available-values="availablePageSizeValues"
        />
      </div>
      <div class="d-flex">
        <TableMainSearchField v-model="search"/>

        <FormSearchSelector
          v-model="site"
          class="ml-2 website-search"
          id="website"
          placeholder="Zoek website..."
          endpoint="/api/websites"
          titleField="domainname"

          @select-item="setWebsiteParam"

          :infinite-scrolling="true"
          :table="true"

          v-slot="item"
        >
          <div class="p-1 item">
            {{ item.domainname }}
          </div>
        </FormSearchSelector>

        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
      <CardTabs class="card-tabs"
        v-model="state"
        :tabs="tabs"
      />
    </template>

    <template #cell-status="{value}">
      <button
        type='button'
        class="btn"
        :class="value === 'active' ? 'btn-success' : 'btn-danger'"
      >
        {{ value }}
      </button>
    </template>

    <template #cell-orderAmount="{value}">
      <span class="order-amount">
        {{ `€ ${(value + "").replace(/\./, ",")}` }}
      </span>
    </template>

    <template v-if="loaded" #row-action="{item}">
      <TableActionDropdown class="drop" :item="item" :options="options(item, freshRefetch)"/>
    </template>

    <template v-if="shouldMakeTextsBold" #before-row="{item}">
      <span class="d-flex align-items-center older-than-two-days-warning" title="Deze bestelling is ouder dan 2 dagen">
        <svg class="ml-1" xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" fill="#FBBF24" :style="{opacity: item.isOlderThanTwoDays ? 1 : 0}">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
        </svg>
      </span>
    </template>

    <template #cell-orderNumber="{value}">
      <CopyableElement :skeleton-class="skeletonClass"
        :value="value"
        :message="`Succesvol ${value} ordernummer gekopieerd!`"
      >
        {{ value }}
      </CopyableElement>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen bestellingen"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
          <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
        </svg>
      </EmptyStatePlaceholder>
    </template>


  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import CardTabs from "src/layout/CardTabs.vue"
import TableCell from "src/components/Table/TableCell.vue"
import TableDatePickerField from '../components/Inputs/TableDatePickerField.vue'
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import CopyableElement from '../layout/CopyableElement.vue'
import MultiplePageSizesSelection from '@/layout/Table/MultiplePageSizesSelection.vue'
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import RefreshBtn from '../layout/RefreshBtn.vue'
import FormSearchSelector from '../components/Inputs/FormSearchSelector.vue'

import table from "src/mixins/table"
import keepScroll from "src/mixins/keepScroll"

/*
  <div class="delete-icon cancel-icon" @click="confirmDelete(item)">
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  </div>
*/

const MILISECONDS_IN_TWO_DAYS = 172800000

export default {
  metaInfo: {
    title: "Overzicht bestellingen",
  },
  components: {
    HeaderButton,
    CardTabs,
    TableHeader,
    TableMainSearchField,
    RefreshBtn,
    MultiplePageSizesSelection,
    TableCell,
    TableDatePickerField,
    CopyableElement,

    TableActionDropdown,
    FormSelect,
    FormSearchSelector,
    TableTemplate,
    TableSearchField,
    EmptyStatePlaceholder,
    FormSearchSelector,
  },
  mixins: [
    tableFieldOptions,
    keepScroll,
    table({
      pageReference: 'overview-order',

      defaultColumnSizes: {
        orderDate: 140,
        orderNumber: 140,
      },
      columnTranslationMaps: {
        "Bestelnummer": "orderNumber",
        "Besteldatum": "orderDate",
        "Bestelbedrag": "orderAmount",
        "Klant": "customer",
        "Site": "site",
        "E-mail": "email",
        "Track and Trace": "shipmentTrackAndTrace",
      },
      defaultColumns: [
        'Bestelnummer', "Besteldatum", "Bestelbedrag", "Klant", "Site", "E-mail", "Track and Trace"
      ],

      parseParamsBeforeSending: params => {
        const initial = params.orderInitialDate
        const final = params.orderFinalDate

        delete params.orderInitialDate
        delete params.orderFinalDate

        return {
          ...params,
          orderDate: final ? [initial, final] : (initial && [initial]),
        }
      },
      defaultSort: "orderDate",
      defaultOrder: "desc",
      page_size: 100,
      params: {
        orderNumber: "",
        site: "",
        customer: "",
        orderAmount: "",
        site: "",
        search: "",
        email: "",
        orderInitialDate: "",
        orderFinalDate: "",
        page_size: 20,
        state: "NOT_SENT",
      },
      toISOFields: ["orderInitialDate", "orderFinalDate"],
      route: "/api/orders",

      refetchHook: vm => vm.fetchOrdersMetaInfo()
    }),
  ],
  data() {
    return {
      meta: {},

      /**
       * [ Mixin keepScroll ] - localStorageKey: Unique key(one per page) that will be used as a reference to set/get the element's distance from the top
       */
      localStorageKey: "position_scroll_overview_order"
    }
  },
  created() {
    this.fetchOrdersMetaInfo()
  },
  methods: {
    async addOrder() {
      this.$pushModal({
        modal: "AddOrder",
        toBind: {
          callback: this.freshRefetch,
        }
      })
    },

    async fetchOrdersMetaInfo() {
      const states = ["NOT_SENT", "SENT_TO_POSTNL", "SHIPPED", "CANCELED"]
      const fetchTotal = async state => (await this.axios.get("/api/orders", {params: {state}})).data.total

      const meta = await Promise.all(states.map(async state => ({
        state,
        total: await fetchTotal(state),
      })))
      this.meta = meta.reduce((obj, {state, total}) => ({
        ...obj,
        [state]: total,
      }), {})
    },

    async cancelOrder(uid) {
      this.$handlePromise(
        this.axios.delete(`/api/orders/${uid}`)
      )
      this.$success("Bestelling geannuleerd!")
      this.freshRefetch()
    },
    setWebsiteParam(item) {
      if(!item) return;
      const { domainname } = item
      this.site = domainname
      return domainname
    },
    viewOrder(item) {
      if (this.removeCursor) return;
      const referenceRowTarget = document.getElementById(`table-row-${item.uid}`)
      this.setLocalStorageTopDistance({ target: referenceRowTarget})

      this.$router.push(`/admin/order/${item.uid}`).catch(()=>{})
    },
    getWebsiteList(websites) {
      return websites.reduce((str, site) => {
        return !str.length ? `, ${site.domainname}` : site.domainname
      }, "")
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.cancelOrder(item.uid),
        {
          title: "Annuleer bestelling",
          description: `Are you sure you want to cancel the <b>${item.email || item.customer}</b> order?`,
          buttonSave: "Annuleren",
        }
      )
    },
    options(item, freshRefetch) {
      const editAndResend = {
        click: () => this.viewOrder(item),
        id: "edit-and-resend",
        name: "Wijzig en stuur opnieuw",
        icon: "nc-icon nc-settings-tool-66",
      }

      const viewOrder = {
        click: () => this.viewOrder(item),
        id: "view",
        name: "Order bekijken",
        icon: "nc-icon nc-zoom-split",
      }

      switch (this.state) {
        case "NOT_SENT": {
          return [
            {
              click: () => this.viewOrder(item),
              id: "edit",
              name: "Wijzig order",
              icon: "nc-icon nc-settings-tool-66"
            },
            {
              click: async () => {
                this.$pushModal({
                  modal: "OverviewOrderMarkAsBeingShipped",
                  toBind: {
                    order: item,
                    callback: freshRefetch,
                  }
                })
              },
              id: "mark-as-being-shipped",
              name: "Markeren als verzonden naar Klant",
              icon: "nc-icon nc-map-big",
            },
            {
              click: async () => {
                if (await this.$handlePromise(
                  this.axios.delete(`/api/orders/${item.uid}`)
                )) {
                  this.$success("Bestelling geannuleerd!")
                  freshRefetch()
                }
              },
              id: "cancel",
              name: "Annuleer order",
              icon: "nc-icon nc-simple-remove",
            },
          ]
        }
        case "SENT_TO_POSTNL": {
          return [
            editAndResend,
            {
              click: async () => {
                this.$pushModal({
                  modal: "OverviewOrderMarkAsBeingShipped",
                  toBind: {
                    order: item,
                    callback: freshRefetch,
                  }
                })
              },
              id: "mark-as-being-shipped",
              name: "Markeren als verzonden naar Klant",
              icon: "nc-icon nc-map-big",
            },
          ]
        }
        case "SHIPPED": {
          return [viewOrder]
        }
        case "CANCELED": {
          return [editAndResend]
        }
      }
    },
    isOlderThanTwoDays(orderDate) {
      const diff = new Date().getTime() - new Date(orderDate).getTime()
      return diff > MILISECONDS_IN_TWO_DAYS
    },
    setWebsiteParam(item) {
      if(!item) return
      const { domainname } = item;
      this.site = domainname;
      return domainname;
    },
  },
  computed: {
    availablePageSizeValues() {
      return [ 20, 50, 100 ]
    },

    shouldMakeTextsBold() {
      return this.state === "NOT_SENT" || this.state === "SENT_TO_POSTNL"
    },
    tabs() {
      const meta = this.meta
      return [
        {
          name: "Nog niet verzonden",
          id: 'NOT_SENT',
        },
        {
          name: "Afgeleverd aan PostNL",
          id: 'SENT_TO_POSTNL',
        },
        {
          name: "Verzonden naar Klant",
          id: 'SHIPPED',
        },
        {
          name: "Geannuleerd",
          id: 'CANCELED',
        },
      ].map(item => ({...item, number: meta[item.id] || 0}))
    },
    sortOptions() {
      return [
        {
          str: "Asc",
          value: "asc",
        },
        {
          str: "Desc",
          value: "desc",
        },
      ]
    },

    mappedOrders() {
      let arr = this.tableResult
      if (!this.shouldMakeTextsBold) return arr

      return arr.map(item => ({
        ...item,
        isOlderThanTwoDays: this.isOlderThanTwoDays(item.orderDate),
      }))
    },
    table() {
      return this.$refs.table
    },
    capitalize() {
      return [false, false, false, false, false, false, false]
    },
  },
  watch: {
    state() {
      this.page = 1
    },
  },
}

</script>

<style>

.OverviewOrder tr > td.first-child > span {
  display: block;
  padding-left: 14px !important;
}

</style>

<style scoped>

.item {
  transition-duration: .15s;
}

.item:hover {
  background-color: rgba(245,245,245);
}

.older-than-two-days-warning {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.card-tabs {
  transform: translateY(9px);
}

.card-title {
  margin-top: 0;
  margin-bottom: 18px;
}

.website-search {
  width: 100%;
}

.website-search::v-deep input {
  height: 34px;
}

@media (min-width: 992px) {
  .website-search {
    width: initial;
  }
}

</style>
